import { Navigate } from 'react-router-dom'
import { useCurrentUser } from '../Utils/CurrentUserContext'
import { ROUTES } from '../../appRoutes'

interface ProtectedRouteProps {
  children: React.ReactNode
  adminOnly?: boolean
}

export default function ProtectedRoute({ children, adminOnly }: ProtectedRouteProps) {
  const token = localStorage.getItem('token')
  const { user, isAdmin, loading } = useCurrentUser()

  if (!token) {
    return <Navigate to={ROUTES.login} replace />
  }

  if (adminOnly) {
    // Wait until we know who the user is before deciding to redirect.
    if (loading || !user) {
      return null
    }
    if (!isAdmin) {
      return <Navigate to={ROUTES.dashboard} replace />
    }
  }

  return <>{children}</>
}
